<template>
  <v-container class="bodyLogin" fluid>
    <LoginNavbar
      :backgroundImage="'salas_estudio2'"
    />
    <v-card class="topCard">
      <v-row>
        <v-col lg="4" md="4" sm="8" class="bannerLogo">
          <img width="90%" height="90%" :src="logo_usach2" />
        </v-col>
        <v-col lg="8" md="8" sm="12">
          <v-list>
            <v-list-item>

              <v-list-item-content>
                <v-btn
                  color="warning"
                  @click="changeLogin()"
                  :x-small="buttonSize"
                >
                  Ir a Salvoconducto
                </v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-col>
      </v-row>

    </v-card>

    <v-row align="center" justify="center" class="loginSector">
      <v-col cols="12" sm="8" md="5">
        <v-card class="elevation-12">
          <v-toolbar color="#071D49" dark flat>
            <v-toolbar-title>
              Acceso a Permiso Ingreso Estudiante
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form id="formVrae" v-model="valid" :lazy-validation="lazy">
              <v-text-field
                dense
                outlined
                label="Nombre de usuario (correo Usach sin extensión)"
                name="login"
                prepend-icon="mdi-account"
                type="text"
                v-model="user"
                :rules="requiredRules"
                v-on:keyup.enter="login"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                id="password"
                label="Contraseña de correo"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                v-model="pass"
                :rules="requiredRules"
                v-on:keyup.enter="login"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              :disabled="!valid"
              :loading="loading"
              @click="login()"
            >Ingresar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import img from "../../assets/USACH_2.png";
import img1 from "../../assets/LOGO USACH.png";
import img2 from "../../assets/CampusSeguro Icon-2.png";
import logo_usach2 from "../../assets/logo_usach2.jpg";
import LoginNavbar from './LoginNavbar/LoginNavbar';

// import jwtDecode from "jwt-decode";
import { mapActions, } from 'vuex';

import {saveUserToken, } from '../../utils/saveUserToken';

const alumnoNoAutorizadoToken = 'eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiJMb2dpblJlc2VydmEiLCJzdWIiOiIxNTkwNzAwOC01IiwiYXV0aG9yaXRpZXMiOlsiQWx1bW5vLU5vQXV0b3JpemFkbyJdLCJlbWFpbCI6ImNlc2FyLnZlbGFzcXVlei5tQHVzYWNoLmNsIiwiaWRlbnRpZmljYWRvciI6MTMsImlhdCI6MTYzMTM3NTA2N30.HRw_7jzIMUor2PoktMHE43teHDFqC2v6EpeXmu_MDQOa7Us6_6kzUarj3lRWOMG0qlQrFXMpbGzTvl1XM4eZWQ';
const alumnoAutorizadoToken = 'eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiJMb2dpblJlc2VydmEiLCJzdWIiOiIxNTkwNzAwOC01IiwiYXV0aG9yaXRpZXMiOlsiQWx1bW5vLUF1dG9yaXphZG8iXSwiZW1haWwiOiJjZXNhci52ZWxhc3F1ZXoubUB1c2FjaC5jbCIsImlkZW50aWZpY2Fkb3IiOjEzLCJpYXQiOjE2MzEzNzUxMzZ9.wRBI_h5ATgYOzstbIoPqmaz00QmIKE7GehrBcDxp-GQAkmynjhbIn9iDrMF7c8XW-iFV8IpDaC-Gea68p7YnCA';

export default {
  name: 'LoginReserva',
  components: {
    LoginNavbar,
  },
  data() {
    return {
      valid: false,
      requiredRules: [v => !!v || "Este campo es requerido"],
      opcionesDominio: ["@segic.usach.cl", "@usach.cl"],
      logo_usach2: logo_usach2,
      dominio: "@usach.cl",
      menu: false,
      loading: false,
      img1: img1,
      img2: img2,
      img: img,
      lazy: false,
      tipo: "",
      opcionesTipo: [
        {
          name: "Funcionario/Académico/Estudiante",
          value: 1
        },
        {
          name: "Administrador",
          value: 2
        }
      ],
      user: "",
      pass: "",
      nameTitle: "Reserva sala de estudio",
      loginType: 1,
    };
  },

  computed: {
    buttonSize() {
      return this.$vuetify.breakpoint.xs;
    }
  },

  methods: {
    ...mapActions('stepper', [
      'setCurrentStep',
    ]),
    login() {
      var sha1 = require("sha1");
      //console.log(this.mail)
      this.loading = true;
      const userName = this.user.split('@');
      const user = {
        email: `${userName[0]}`,
        password: sha1(this.pass)
      };
      //console.log(user);
      //console.log(user);


      this.axios
        .post(process.env.VUE_APP_BASE_URL + "/login/alumno", user)
        .then(response => {
          //console.log(response.data);
          //console.log('haciendo la mutación')
          // const role = saveUserToken(this, response.data);
          this.$session.start();
          //console.log(response.data);
          console.log(response.data);
          const role = saveUserToken(this, response.data);
          if (role === 'Alumno-NoAutorizado') {
            this.$router.push({ name: "regAlumno" });
          }
          else {
            if (role === 'Alumno-Autorizado') {
              this.$router.push({ name: "studentPermission" });
            }
          }
          /*
          TODO:Por alguna razón no funca
          this.showAlert("success", "ingreso correcto");
          this.$session.set("userType", Decode.userType); */

          //console.log(Decode.userType);

          this.loading = false;
        })
        .catch(error => {
          //console.error(error.response.data);
          this.loading = false;
          console.log(error);
          alert(error.response);
        });
    },
    changeLogin(){
      this.$router.push({path: '/login'});
    }
  }
};
</script>
<style scoped>
.text-center {
  margin-left: 3px !important;
}

.bannerLogo {
  width: 100%;
  height: 100%;
  padding: 20px;
}

.topCard {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 3%;
  width: auto;
  max-width: 40%;
  height: 20%;
  margin-top: 7%;
  margin-bottom: 3%;
}

@media (max-width: 960px) {
  .topCard {
    padding: 0;
    margin-bottom: 12%;
  }
}

@media (max-width: 768px) {
  .topCard {
    padding: 0;
    margin-bottom: 15%;
  }
}

@media only screen and (max-width: 600px) {
  .topCard {
    margin-bottom: 15%;
    margin-top: 20%;
    font-size: 10px;
    max-width: 100%;
  }
}

.bodyLogin {
  flex-direction: column;
  justify-content: space-evenly;
}

.parallax {
  position: fixed;
  z-index: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  filter: blur(0.3rem);
}

.notice {
  max-width: 800px;
}

</style>
